import React from "react"
import Box from '@mui/material/Box';
import { fto } from "../../../../../../../constants";

export const ImageFTO = () => {

return(
<div>

<Box sx={{ m:8}}>
                        <img 
                                    src={fto}
                                    width="70%"
                                    height="auto"
                                    alt="fto_gene"
                            />          
</Box>

</div>
)
}